// FocusTrapWrapper.jsx
import React, { useEffect, useRef } from "react";

const FOCUSABLE_SELECTORS = `
  a[href], area[href], input:not([disabled]),
  select:not([disabled]), textarea:not([disabled]),
  button:not([disabled]), iframe, object, embed,
  [tabindex]:not([tabindex="-1"]), [contenteditable]
`;

const FocusTrapWrapper = ({ children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const getFocusableElements = () =>
      Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS)).filter(
        (el) => el.offsetParent !== null // skip hidden elements
      );

    const focusableEls = getFocusableElements();
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    firstEl?.focus();

    const handleKeyDown = (e) => {
      if (e.key !== "Tab") return;

      const activeEl = document.activeElement;
      const focusable = getFocusableElements();

      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        // Back tab
        if (activeEl === first || !container.contains(activeEl)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Forward tab
        if (activeEl === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    container.addEventListener("keydown", handleKeyDown);

    return () => {
      container.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div ref={containerRef} tabIndex={-1}>
      {children}
    </div>
  );
};

export default FocusTrapWrapper;
